import { FC } from 'react';
import { PreloaderWrapperProps } from 'shared/ui/preloader';
import styles from './styles.module.scss';

export const ClinicsWrapper: FC<PreloaderWrapperProps> = ({ children }) => {
	return <div className={styles['clinics-list__wrapper']}>{children}</div>;
};
